import { Loader2 } from 'lucide-react';

/** Shown while a lazy route chunk is downloading. */
export function RouteFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-surface-muted"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-6 w-6 animate-spin text-brand-600" aria-hidden="true" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
